import React, { Component } from 'react';
import { Card, ModalBody, ModalNext, withModalContext } from '@jutro/components';
import { MetadataContent } from "@jutro/uiconfig";
import metadata from './VinPopup.metadata.json5';
import './VinPopup.messages';
import styles from './VinPopUp.module.scss';


class VinPopUp extends Component {
    state = {};

    handleDismiss = (evt) => {
        // eslint-disable-next-line react/prop-types
        const { onResolve } = this.props;
        evt.stopPropagation();
        onResolve();
    }

    render() {
        const overrides = {
            gotItButton: {
                content: 'Got It'
            }
        };
        const resolvers = {
            resolveCallbackMap: {
                onCancel: this.handleDismiss
            },
            resolveClassNameMap: styles,

        };


        return (
            <ModalNext isOpen={this.props.isOpen}>
                <ModalBody>
                    <Card id="standardizedPanel" className={styles.panelStyle}>
                        <MetadataContent
                        uiProps={metadata.pageContent}
                        overrideProps={overrides}
                        {...resolvers}/>
                    </Card>
                </ModalBody>
            </ModalNext>
        );
    }
}

export default withModalContext(VinPopUp);
